var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticClass:"font-md",class:{ 'sp-layout': _vm.currentWidth < 769 }},[_c('router-view',{key:_vm.$route.fullPath,style:({ flex: '1 1 auto' })}),_c('loading',{attrs:{"active":_vm.isLoading,"is-full-page":"","z-index":_vm.zIndex}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }